import { render } from "./BookingExtras.vue?vue&type=template&id=480cd269"
import script from "./BookingExtras.vue?vue&type=script&lang=js"
export * from "./BookingExtras.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingExtras.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "480cd269"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('480cd269', __exports__)) {
    api.reload('480cd269', __exports__)
  }
  
  module.hot.accept("./BookingExtras.vue?vue&type=template&id=480cd269", () => {
    api.rerender('480cd269', render)
  })

}


export default __exports__